import easternLocales from '@/i18n/realtime-voice-call-locales-eastern.json';
import westernLocales from '@/i18n/realtime-voice-call-locales-western.json';
import { normalizeLocale } from '@/i18n/config';

const catalog = { ...westernLocales, ...easternLocales };

export type RealtimeVoiceCallCopy = (typeof catalog)['en'];

export function getRealtimeVoiceCallCopy(
  locale: string | null | undefined
): RealtimeVoiceCallCopy {
  return catalog[normalizeLocale(locale)];
}
